(function () {
  var SECTION_SELECTOR = '[data-cd-story-time]';
  var sections = [];
  var scheduled = false;
  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function isMobile() {
    return window.matchMedia('(max-width: 1024px)').matches;
  }

  function shouldReduceMotion() {
    return !!(prefersReducedMotion && prefersReducedMotion.matches);
  }

  function appendLine(node, text) {
    var line = document.createElement('span');
    line.className = 'cd-story-time__lineflow-line';
    line.setAttribute('aria-hidden', 'true');

    var inner = document.createElement('span');
    inner.className = 'cd-story-time__lineflow-text';
    inner.textContent = text;

    line.appendChild(inner);
    node.appendChild(line);
  }

  function splitRenderedLines(node, text) {
    var words = text.split(/\s+/).filter(Boolean);
    if (!words.length) return [text];

    node.textContent = '';

    var spans = words.map(function (word, index) {
      var span = document.createElement('span');
      span.textContent = index === words.length - 1 ? word : word + ' ';
      span.style.display = 'inline-block';
      span.style.whiteSpace = 'pre';
      node.appendChild(span);
      return span;
    });

    var lines = [];
    var current = [];
    var currentTop = null;

    spans.forEach(function (span) {
      var top = span.offsetTop;
      if (currentTop === null) currentTop = top;
      if (Math.abs(top - currentTop) > 2 && current.length) {
        lines.push(current.join('').trim());
        current = [];
        currentTop = top;
      }
      current.push(span.textContent || '');
    });

    if (current.length) {
      lines.push(current.join('').trim());
    }

    node.textContent = '';
    return lines.length ? lines : [text];
  }

  function buildLineflow(root) {
    if (!root) return;

    root.querySelectorAll('[data-cd-story-lineflow]').forEach(function (node) {
      var originalHtml = node.getAttribute('data-cd-story-lineflow-original-html');
      if (!originalHtml) {
        originalHtml = node.innerHTML || '';
        node.setAttribute('data-cd-story-lineflow-original-html', originalHtml);
      }

      var label = node.getAttribute('data-cd-story-lineflow-original-label');
      if (!label) {
        label = (node.textContent || '').replace(/\s+/g, ' ').trim();
        node.setAttribute('data-cd-story-lineflow-original-label', label);
      }

      var manualParts = originalHtml.split(/<br\s*\/?>(?:\s*)?/i).map(function (part) {
        var decoder = document.createElement('span');
        decoder.innerHTML = part;
        return (decoder.textContent || '').replace(/\s+/g, ' ').trim();
      }).filter(Boolean);

      node.setAttribute('aria-label', label);
      node.setAttribute('data-cd-story-lineflow-ready', 'true');
      node.innerHTML = '';

      if (manualParts.length > 1) {
        manualParts.forEach(function (part) {
          appendLine(node, part);
        });
        return;
      }

      splitRenderedLines(node, label).forEach(function (lineText) {
        appendLine(node, lineText);
      });
    });
  }

  function setItemState(node, progress, y, startScale) {
    if (!node) return;
    var local = easeInOutCubic(clamp(progress, 0, 1));
    var opacity = clamp(local, 0, 1);
    var translateY = (1 - local) * y;
    var scale = startScale + local * (1 - startScale);

    node.style.setProperty('--cd-story-item-opacity', opacity.toFixed(4));
    node.style.setProperty('--cd-story-item-y', translateY.toFixed(2) + 'px');
    node.style.setProperty('--cd-story-item-scale', scale.toFixed(4));
  }

  function setTileState(node, progress) {
    if (!node) return;
    var local = easeInOutCubic(clamp(progress, 0, 1));
    var opacity = clamp(local, 0, 1);
    var translateY = (1 - local) * 24;
    var scale = 0.96 + local * 0.04;

    node.style.setProperty('--cd-story-tile-opacity', opacity.toFixed(4));
    node.style.setProperty('--cd-story-tile-y', translateY.toFixed(2) + 'px');
    node.style.setProperty('--cd-story-tile-scale', scale.toFixed(4));
  }

  function setLineState(node, progress) {
    if (!node) return;

    var lines = node.querySelectorAll('.cd-story-time__lineflow-text');
    lines.forEach(function (line, index) {
      var local = easeInOutCubic(clamp(progress - index * 0.1, 0, 1));
      var opacity = clamp(local, 0, 1);
      var y = (1 - local) * 1.08;

      line.style.setProperty('--cd-story-line-opacity', opacity.toFixed(4));
      line.style.setProperty('--cd-story-line-y', y.toFixed(4) + 'em');
    });
  }

  function collectSections() {
    sections = Array.prototype.slice.call(document.querySelectorAll(SECTION_SELECTOR))
      .map(function (section) {
        buildLineflow(section);

        return {
          section: section,
          intro: section.querySelector('[data-cd-story-intro]'),
          flow: section.querySelector('[data-cd-story-flow]'),
          overlay: section.querySelector('[data-cd-story-overlay]'),
          content: section.querySelector('[data-cd-story-content]'),
          contentMedia: section.querySelector('[data-cd-story-content-media]'),
          rows: Array.prototype.slice.call(section.querySelectorAll('[data-cd-story-row]')).map(function (row) {
            return {
              root: row,
              items: Array.prototype.slice.call(row.querySelectorAll('[data-cd-story-row-item]:not([data-cd-story-lineflow])')),
              lineflow: Array.prototype.slice.call(row.querySelectorAll('[data-cd-story-lineflow]')),
              tiles: Array.prototype.slice.call(row.querySelectorAll('[data-cd-story-tile]'))
            };
          }),
          flowItems: Array.prototype.slice.call(section.querySelectorAll('[data-cd-story-flow-item]:not([data-cd-story-lineflow])')),
          flowLineflow: Array.prototype.slice.call(section.querySelectorAll('[data-cd-story-flow-item][data-cd-story-lineflow]'))
        };
      })
      .filter(function (item) {
        return item.intro && item.flow && item.overlay && item.content;
      });
  }

  function updateRowMotion(item, vh) {
    item.rows.forEach(function (row) {
      var rect = row.root.getBoundingClientRect();
      var entry = clamp((vh * 0.9 - rect.top) / (vh * 0.5), 0, 1);

      row.items.forEach(function (node) {
        var offset = parseFloat(node.getAttribute('data-cd-story-offset') || '0');
        setItemState(node, (entry - offset) / 0.46, 34, 0.985);
      });

      row.tiles.forEach(function (tile) {
        var offset = parseFloat(tile.getAttribute('data-cd-story-offset') || '0');
        setTileState(tile, (entry - 0.1 - offset) / 0.38);
      });

      row.lineflow.forEach(function (node) {
        var offset = parseFloat(node.getAttribute('data-cd-story-offset') || '0');
        setLineState(node, (entry - offset) / 0.42);
      });
    });
  }

  function updateFlowMotion(item, vh) {
    var introRect = item.intro.getBoundingClientRect();
    var flowRect = item.flow.getBoundingClientRect();
    var contentRect = item.content.getBoundingClientRect();
    var contentCenterY = contentRect.top + contentRect.height * 0.5;
    var introTravel = Math.max(item.intro.offsetHeight - vh * 0.36, vh * 0.4);
    var introProgress = clamp((-introRect.top) / introTravel, 0, 1);

    var overlayProgress = easeInOutCubic(clamp((introProgress - 0.64) / 0.22, 0, 1));
    var handoffAnchor = isMobile() ? vh * 0.54 : vh * 0.5;
    var releaseWindow = isMobile() ? vh * 0.18 : vh * 0.14;
    var handoffProgress = clamp((handoffAnchor - contentCenterY) / releaseWindow, 0, 1);
    var contentProgress = clamp((vh * 0.88 - contentRect.top) / (vh * 0.52), 0, 1);
    var contentLocal = easeInOutCubic(contentProgress);
    var overlayOpacity = clamp(overlayProgress * (1 - handoffProgress), 0, 1);
    var overlayActive =
      flowRect.top < vh &&
      flowRect.bottom > 0 &&
      overlayOpacity > 0.002 &&
      handoffProgress < 1;
    var overlayScale = 0.94 + overlayProgress * 0.06;
    var overlayImageY = (1 - overlayProgress) * 22;
    var overlayImageScale = 1.06 - overlayProgress * 0.06;
    var contentMediaProgress = easeInOutCubic(clamp((handoffProgress - 0.06) / 0.5, 0, 1));

    item.overlay.style.opacity = overlayActive ? overlayOpacity.toFixed(4) : '0';
    item.overlay.style.visibility = overlayActive ? 'visible' : 'hidden';
    item.overlay.style.transform =
      'translate(-50%, -50%) scale(' + overlayScale.toFixed(4) + ')';
    item.overlay.style.setProperty('--cd-story-flow-image-y', overlayImageY.toFixed(2) + 'px');
    item.overlay.style.setProperty('--cd-story-flow-image-scale', overlayImageScale.toFixed(4));

    if (item.contentMedia) {
      item.contentMedia.style.opacity = contentMediaProgress.toFixed(4);
      item.contentMedia.style.visibility = contentMediaProgress > 0.002 ? 'visible' : 'hidden';
      item.contentMedia.style.setProperty('--cd-story-item-opacity', contentMediaProgress.toFixed(4));
      item.contentMedia.style.setProperty('--cd-story-item-y', ((1 - contentMediaProgress) * 26).toFixed(2) + 'px');
      item.contentMedia.style.setProperty('--cd-story-item-scale', (0.975 + contentMediaProgress * 0.025).toFixed(4));
      item.contentMedia.style.setProperty('--cd-story-flow-image-y', ((1 - contentMediaProgress) * 12).toFixed(2) + 'px');
      item.contentMedia.style.setProperty('--cd-story-flow-image-scale', (1.04 - contentMediaProgress * 0.04).toFixed(4));
    }

    item.flowLineflow.forEach(function (node) {
      var offset = parseFloat(node.getAttribute('data-cd-story-offset') || '0');
      setLineState(node, (contentLocal - offset) / 0.38);
    });

    item.flowItems.forEach(function (node) {
      if (node === item.contentMedia) return;
      var offset = parseFloat(node.getAttribute('data-cd-story-offset') || '0');
      setItemState(node, (contentLocal - offset) / 0.42, 36, 0.985);
    });
  }

  function setReducedState(item) {
    item.rows.forEach(function (row) {
      row.items.forEach(function (node) {
        setItemState(node, 1, 0, 1);
      });
      row.tiles.forEach(function (node) {
        setTileState(node, 1);
      });
      row.lineflow.forEach(function (node) {
        setLineState(node, 1);
      });
    });

    item.flowItems.forEach(function (node) {
      setItemState(node, 1, 0, 1);
    });
    item.flowLineflow.forEach(function (node) {
      setLineState(node, 1);
    });

    if (item.overlay) {
      item.overlay.style.opacity = '0';
      item.overlay.style.visibility = 'hidden';
      item.overlay.style.transform = 'translate(-50%, -50%) scale(1)';
    }

    if (item.contentMedia) {
      item.contentMedia.style.opacity = '1';
      item.contentMedia.style.visibility = 'visible';
    }
  }

  function updateSection(item) {
    var vh = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!vh) return;

    if (shouldReduceMotion()) {
      setReducedState(item);
      return;
    }

    updateRowMotion(item, vh);
    updateFlowMotion(item, vh);
  }

  function updateAll() {
    sections.forEach(updateSection);
    scheduled = false;

    if (
      window.CDCleerHeaderTheme &&
      typeof window.CDCleerHeaderTheme.refresh === 'function'
    ) {
      window.CDCleerHeaderTheme.refresh();
    }
  }

  function requestUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateAll);
  }

  function init() {
    collectSections();
    requestUpdate();
    setTimeout(requestUpdate, 80);
    setTimeout(requestUpdate, 240);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', init);
  window.addEventListener('orientationchange', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);

  if (
    prefersReducedMotion &&
    typeof prefersReducedMotion.addEventListener === 'function'
  ) {
    prefersReducedMotion.addEventListener('change', init);
  }
})();
